import {Component, Element, Fragment, h, Prop, State, Watch} from "@stencil/core";
import { _debug } from "../../../common/debugger/debugger";
// expects <menu>, <ul> or <ol> child with links (<a role="menuitem">)
// shows currently selected menu item by comparing to current url
// hides slotted menu items by default
// toggles menu on click or keyboard action
// shows menu as fixed floating flyout below the button

@Component({
  tag: "m-menu-dropdown",
  styleUrl: "./styles.scss",
  shadow: true,
})
export class MenuDropdown {

  @Element() el: HTMLElement;

  @Prop() uid = 'menu-' + Math.floor(Math.random() * 100);
  @Prop() ordered;
  @Prop() links;

  @State() currentActivePage;

  @State() menuopen;

  @Watch('links')
  getCurrentActivePage() {
    this.links.map((page) => {
      if (page.active) {
        this.currentActivePage = page;
      }
    })
  }

  togglePopup() {
    _debug('toggle menu open/close')
    this.menuopen = !this.menuopen;   
  }

  closePopup() {
    this.menuopen = false;    
  }

  componentDidLoad() {
    document.addEventListener('click', this.handleClick.bind(this));
    document.addEventListener('touchend', this.handleClick.bind(this));
    document.addEventListener('focus', this.handleClick.bind(this));
  }

  handleClick(evt) {
    // const { target } = evt;

    const target = evt.composedPath()[0];

    let isDescendant = false;

    if (evt.composedPath() && evt.composedPath().length > 0) {
      evt.composedPath().forEach(element => {
        if (this.el === element) {
          isDescendant = true;
        }
      });
    }

    if (isDescendant || this.el.contains(target)) {
      return;
    }
    this.closePopup()
  }

  render() {
    return (
      <Fragment>
        <div class="wrapper">
          {
            this.currentActivePage && (
              <span class="counter">{ this.currentActivePage?.index + 1}</span>
            )
          }

          <button type="button"
            id={'button-' + this.uid}
            aria-haspopup="true"
            onClick={() => this.togglePopup()}
            aria-activedescendant={this.uid + '_item_' + this.currentActivePage?.index}
            aria-controls={'menu-' + this.uid}
            {... !this.menuopen ? { ariaExpanded: true } : {}}>
            {this.currentActivePage?.label}
            {
              this.menuopen && (
                <c-icon name="up"></c-icon>
              )
            }
            {
              !this.menuopen && (
                <c-icon name="down"></c-icon>
              )
            }
          </button>
        </div>

        <div class="flyout">
          {
            <ol role="menu" id={'menu-' + this.uid}
              {... !this.menuopen ? { class: 'visually-hidden' } : {}}>

              {
                this.links && this.links.map((page) => (
                  <li>
                    <a
                      role="menuitem"
                      id={this.uid + '_item_' + page.index}
                      onClick={() => this.togglePopup()}
                      href={page.url}
                      {... !page['active'] ? {} : { ariaDisabled: true }}
                      title={page.label}>{page.label}</a>
                  </li>
                ))
              }
            </ol>
          }
        </div>
      </Fragment>

    );
  }
}
